export default{
    async getDashboardData({}, param = null){
        let url = this.$api.tenantAdmin.dashboard.getData;
        if (param) {
            url += '?';
            url += Object.entries(param).map(([key, value]) =>
                key + '=' + value
            ).join('&');
        }
        return await this.$axios.$get(
            url
        )
    },
    async getNotificationDetail({}, id){
        let result = null;
        await this.$axios.$post(
            this.$api.tenantAdmin.dashboard.getNotificationDetail,
            {id: id}
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
        })
        return result;
    }
}